import React, { FC } from 'react';
import { useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useModal } from 'store/modal';
import { buildClientEntity, buildClientUrl } from 'utils/helpers/client';
import { useActiveClientContext } from 'store/active-client';
import UpdateEntity from 'components/crud/UpdateEntity';
import { useTranslation } from 'react-i18next';
import RoleForm from '../../components/RoleForm';
import { IInputs } from '../../components/types';
import { IRole } from '../../types';

interface IProps {
  role: IRole;
}
const EditForm: FC<IProps> = ({ role }: IProps) => {
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();
  const { showModal } = useModal();
  const { client } = useActiveClientContext();

  const methods = useForm<IInputs>({
    defaultValues: {
      ...role,
    },
  });

  return (
    <UpdateEntity
      id={id}
      entity="roles"
      methods={methods}
      onSuccess={(res: any) => {
        const { name } = res.data;
        showModal({
          type: 'success',
          content: (
            <>
              {t('structure.roles.editSuccessMsg')}&nbsp;
              <span className="font-weight-bold text-break">{name}</span>.
            </>
          ),
        });
      }}
      queryKey={[buildClientEntity('role', client), { id }]}
      onSuccessPushToLink={buildClientUrl('/structure/roles', client)}
    >
      {(update: any) => (
        <RoleForm
          title={t('structure.roles.editTitle')}
          methods={methods}
          handleSubmit={update}
          btnLabel={t('common.save')}
        />
      )}
    </UpdateEntity>
  );
};

export default EditForm;
